import React from "react";

export const FormInput = React.forwardRef(
	(
		{
			label,
			icon: Icon = null,
			required = false,
			error,
			disabled = false,
			...props
		},
		ref
	) => (
		<div className="space-y-1 w-full">
			<label className="text-sm font-medium text-gray-700">
				{label} {required && <span className="text-red-500">*</span>}
			</label>
			<div className="relative">
				{Icon && (
					<div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
						{Icon}
					</div>
				)}
				<input
					aria-label={label}
					ref={ref}
					className={`w-full ${
						Icon ? "pl-10" : "pl-4"
					} pr-3 py-2 rounded-lg border focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-colors
                        ${
													error ? "border-red-500 bg-red-50" : "border-gray-200"
												}
                        ${disabled ? "bg-gray-50 text-gray-500" : ""}`}
					disabled={disabled}
					{...props}
				/>
			</div>
			{error && <p className="text-sm text-red-500 mt-1">{error}</p>}
		</div>
	)
);
